<template>
 <!-- <div id="app"> -->
<v-app id="inspire" class="CSChatThai" style="overflow-y: hidden;background: white;">
    <main>
      <div class="mb-5">
        <Navbar/>
      </div>
      <v-content style="height: calc(100vh - 64px);" v-if="url_redirect">
         <v-layout
          column
          align-center
          justify-center
          id="desktop"
          class="white--text hidden-sm-and-down"
          style="background-color: white !important;background-size: 100% 100%;height: calc(100% - 5vh); width: 100vw; background-repeat: no-repeat;margin-top: 4vh; overflow-y: hidden;"
        >
          <v-container grid-md text-xs-center>
            <v-layout row style="align-items: center; margin-top: 10vh;" justify-center = true>
              <v-flex sm2 md2 lg2 xl2></v-flex>
              <v-flex sm8 md8 lg8 xl8  v-if="progress">
                <v-progress-circular v-if="progress" :size="250" :width="10" style="margin: auto;" indeterminate color="blue"></v-progress-circular>
              </v-flex>
              <v-flex sm8 md8 lg8 xl8 v-else-if="type=='first'">
                <v-layout row style="justify-content: center;">
                <v-flex sm6 md6 lg6 xl6>
                  <v-card class="elevation-24" flat style="margin: 0px; width: 33vw;border-radius: 10px; background: #2562ae;">
                    <v-card-title primary-title style="width: 33vw;">
                     <v-layout row align-center justify-center>
                        <div class="headline Kanit">
                          <img src="/static/img/icons/logoonechat_full-white.png" style="height: 70px;">
                        </div>
                      </v-layout>
                    </v-card-title>
                   <div style="padding:0px 15%; color: black;">
                    <p style="color: white;font-weight: bold;">{{$t('Login.titleLogin1')}} <br/>{{$t('Login.titleLogin2')}}</p>
                     <v-btn class="btnloginwebOneid text-transform" @click="loginRedirect()">{{$t('Login.typeLogin1')}}</v-btn>

                     <span class="textor">  {{$t('Login.conjunction')}}  </span>

                     <v-btn class="btnloginwebOneid_white text-transform" @click="type='phone'" style="margin-bottom: 30px;">{{$t('Login.typeLogin2')}}</v-btn>
                   </div>
                 </v-card>
              <div style="text-align: right !important;">
               </div>
             </v-flex>
           </v-layout>
              </v-flex>



               <v-flex sm8 md8 lg8 xl8 v-else-if="type=='phone'">
                <v-layout row style="justify-content: center;">
                <v-flex sm6 md6 lg6 xl6>
                  <v-card class="elevation-24" flat style="margin: 0px; width: 33vw;border-radius: 10px; background: #2562ae;">
                    <v-card-title primary-title style="width: 33vw;">
                     <v-layout row align-center justify-center>
                        <div class="headline Kanit">
                          <img src="/static/img/icons/logoonechat_full-white.png" style="height: 70px;">
                        </div>
                      </v-layout>
                    </v-card-title>
                   <div style="padding:0px 15%; color: black;">
               <v-text-field
                        solo
                        :label="$t('Login.phone')"
                        v-model="phone"
                        class="CSChatThai"
                        style="text-align:center; color: white !important;"
                        @keyup.enter="otp()"
                        mask="###-###-####"
                        prepend-inner-icon="phone"
                      ></v-text-field>

                     <v-btn class="btnloginwebOneid text-transform" @click="otp()" :disabled="phone === ''" :loading="loading" style="margin-bottom: 30px;width: 40%;">{{$t('Login.Button.sendotp')}}</v-btn>
                   </div>
                 </v-card>
              <div style="text-align: right !important;">
               </div>
             </v-flex>
           </v-layout>
              </v-flex>
              <v-flex sm8 md8 lg8 xl8 v-else-if="type=='otp'">
                <v-layout row style="justify-content: center;">
                <v-flex sm6 md6 lg6 xl6>
                  <v-card class="elevation-24" flat style="margin: 0px; width: 33vw;border-radius: 10px; background: #2562ae;">
                    <v-card-title primary-title style="width: 33vw;">
                     <v-layout row align-center justify-center>
                        <div class="headline Kanit">
                          <img src="/static/img/icons/logoonechat_full-white.png" style="height: 70px;">
                        </div>
                      </v-layout>
                    </v-card-title>
                   <div style="padding:0px 15%; color: black;">
                    <p style="color: white;">{{$t('Login.phone')}}: {{phone}}</p>
                    <p style="color: white;" v-if="Refcode">Refcode: {{Refcode}}</p>
                    <v-layout row justify-center align-center>
                    <v-flex sm8 md8 lg8 xl8>
                      <v-text-field
                        solo
                        label="otp"
                        v-model="otpCode"
                        class="CSChatThai"
                        maxlength="6"
                        style="text-align:center; color: white !important;"
                        @keyup.enter="loginWithotp()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex sm4 md4 lg4 xl4>
                      <v-btn depressed class="btnloginwebOneid_white text-transform" style="width: 40%; margin-top: -24px !important;" :disabled="counting" @click="otp()">
                          <countdown v-if="counting" :time="60000" @end="handleCountdownEnd">
                          <template slot-scope="props">{{ props.totalSeconds }} {{$t('Login.Button.time')}} </template>
                        </countdown>
                        <span v-if="!counting">{{$t('Login.Button.resend')}} </span>
                      </v-btn>
                    </v-flex>
                  </v-layout>

                     <v-btn class="btnloginwebOneid" @click="loginWithotp()" :disabled="otpCode.length != 6" style="margin-bottom: 30px;width: 40%;">{{$t('Login.Button.login')}}</v-btn>
                   </div>
                 </v-card>
              <div style="text-align: right !important;">
               </div>
             </v-flex>
           </v-layout>
              </v-flex>
              <v-flex sm2 md2 lg2 xl2></v-flex>
            </v-layout>
          </v-container>
          <Download/>
        </v-layout>

        <!-- mobile -->
        <v-layout
         column
         align-center
         justify-center
         id="mobile"
         class="white--text hidden-md-and-up"
         style="background-color: white !important;background-size: 100% 100%;height: calc(100% - 5vh); width: 100vw; background-repeat: no-repeat;margin-top: 4vh; overflow-y: hidden;"
       >
         <v-container grid-md text-xs-center style="overflow-y: scroll;">
           <v-layout row style="align-items: center; margin-top: 10vh;" justify-center = true>
             <v-flex sm2 md2 lg2 xl2></v-flex>
             <v-flex sm8 md8 lg8 xl8  v-if="progress">
               <v-progress-circular v-if="progress" :size="50" :width="10" style="margin: auto;" indeterminate color="blue"></v-progress-circular>
             </v-flex>
             <v-flex sm8 md8 lg8 xl8 v-else-if="type=='first'">
               <v-layout row style="justify-content: center;">
               <v-flex sm6 md6 lg6 xl6>
                 <v-card class="elevation-24" flat style="margin: 0px; width: 90vw;border-radius: 10px; background: #2562ae;">
                   <v-card-title primary-title style="width: 90vw;">
                    <v-layout row align-center justify-center>
                       <div class="headline Kanit">
                         <img src="/static/img/icons/logoonechat_full-white.png" style="height: 70px;">
                       </div>
                     </v-layout>
                   </v-card-title>
                  <div style="padding:0px 15%; color: black;">
                   <p style="color: white;font-weight: bold;">{{$t('Login.titleLogin1')}} <br/>{{$t('Login.titleLogin2')}}</p>
                    <v-btn class="btnloginwebOneid" @click="loginRedirect()">{{$t('Login.typeLogin1')}}</v-btn>

                    <span class="textor">  {{$t('Login.conjunction')}}  </span>

                    <v-btn class="btnloginwebOneid_white" @click="type='phone'" style="margin-bottom: 30px; width: 95%;">{{$t('Login.typeLogin2')}}</v-btn>
                  </div>
                </v-card>
             <div style="text-align: right !important;">
              </div>
            </v-flex>
          </v-layout>
             </v-flex>



              <v-flex sm8 md8 lg8 xl8 v-else-if="type=='phone'">
               <v-layout row style="justify-content: center;">
               <v-flex sm6 md6 lg6 xl6>
                 <v-card class="elevation-24" flat style="margin: 0px; width: 90vw;border-radius: 10px; background: #2562ae;">
                   <v-card-title primary-title style="width: 90vw;">
                    <v-layout row align-center justify-center>
                       <div class="headline Kanit">
                         <img src="/static/img/icons/logoonechat_full-white.png" style="height: 70px;">
                       </div>
                     </v-layout>
                   </v-card-title>
                  <div style="padding:0px 15%; color: black;">
              <v-text-field
                       solo
                       :label="$t('Login.phone')"
                       v-model="phone"
                       class="CSChatThai"
                       style="text-align:center; color: white !important;"
                       @keyup.enter="otp()"
                       mask="###-###-####"
                       prepend-inner-icon="phone"
                     ></v-text-field>

                    <v-btn class="btnloginwebOneid" :disabled="phone === ''" :loading="loading" @click="otp()" style="margin-bottom: 30px;width: 40%;">{{$t('Login.Button.sendotp')}}</v-btn>
                  </div>
                </v-card>
             <div style="text-align: right !important;">
              </div>
            </v-flex>
          </v-layout>
             </v-flex>
             <v-flex sm8 md8 lg8 xl8 v-else-if="type=='otp'">
               <v-layout row style="justify-content: center;">
               <v-flex sm6 md6 lg6 xl6>
                 <v-card class="elevation-24" flat style="margin: 0px; width: 90vw;border-radius: 10px; background: #2562ae;">
                   <v-card-title primary-title style="width: 90vw;">
                    <v-layout row align-center justify-center>
                       <div class="headline Kanit">
                         <img src="/static/img/icons/logoonechat_full-white.png" style="height: 70px;">
                       </div>
                     </v-layout>
                   </v-card-title>
                  <div style="padding:0px 15%; color: black;">
                   <p style="color: white;">{{$t('Login.phone')}}: {{phone}}</p>
                   <p style="color: white;" v-if="Refcode">Refcode: {{Refcode}}</p>
                   <v-layout row justify-center align-center>
                   <v-flex sm8 md8 lg8 xl8>
              <v-text-field
                       solo
                       label="otp"
                       v-model="otpCode"
                       class="CSChatThai"
                       maxlength="6"
                       style="text-align:center; color: white !important;"
                       @keyup.enter="loginWithotp()"
                     ></v-text-field>
                   </v-flex>
                   <v-flex sm4 md4 lg4 xl4>
                     <v-btn depressed class="btnloginwebOneid_white text-transform" style="width: 40%; margin-top: -24px !important;" :disabled="counting" @click="otp()">
                         <countdown v-if="counting" :time="60000" @end="handleCountdownEnd">
                         <template slot-scope="props">{{ props.totalSeconds }} {{$t('Login.Button.time')}} </template>
                       </countdown>
                       <span v-if="!counting">{{$t('Login.Button.resend')}} </span>
                     </v-btn>
                   </v-flex>
                 </v-layout>

                    <v-btn class="btnloginwebOneid text-transform" @click="loginWithotp()" :disabled="otpCode.length != 6" style="margin-bottom: 30px;width: 40%;">{{$t('Login.Button.login')}}</v-btn>
                  </div>
                </v-card>
             <div style="text-align: right !important;">
              </div>
            </v-flex>
          </v-layout>
             </v-flex>
             <v-flex sm2 md2 lg2 xl2></v-flex>
           </v-layout>
         </v-container>
         <Download/>
       </v-layout>
      </v-content>
      <v-content style="height: calc(100vh - 64px);" v-else>
        <v-layout
          column
          align-center
          justify-center
          id="desktop"
          class="white--text hidden-sm-and-down"
          style="background-color: white !important;background-size: 100% 100%;height: calc(100% - 5vh); width: 100vw; background-repeat: no-repeat;margin-top: 4vh; overflow-y: hidden;"
        >
          <v-container grid-md text-xs-center>
            <v-layout row style="align-items: center; margin-top: 10vh;" justify-center = true>
              <v-flex sm2 md2 lg2 xl2></v-flex>
              <v-flex sm8 md8 lg8 xl8  v-if="progress">
                <v-progress-circular v-if="progress" :size="250" :width="10" style="margin: auto;" indeterminate color="blue"></v-progress-circular>
              </v-flex>
              <v-flex sm8 md8 lg8 xl8 v-else>
                <v-layout row style="justify-content: center;">
                <v-flex sm6 md6 lg6 xl6>
                  <v-card class="elevation-24" flat style="margin: 0px; width: 33vw;border-radius: 10px; background: #2562ae;">
                    <v-card-title primary-title style="width: 33vw;">
                     <v-layout row align-center justify-center>
                        <div class="headline Kanit">
                          <img src="/static/img/icons/logoonechat_full-white.png" style="height: 70px;">
                        </div>
                      </v-layout>
                    </v-card-title>
                   <div style="padding:0px 15%; color: black;">
                     <v-form v-model="valid">

                      <v-text-field
                        solo
                        :label="$t('Login.username')"
                        v-model="username"
                        class="CSChatThai"
                        style="text-align:center; color: white !important;"
                        @keyup.enter="login()"
                        @keypress="isNumandaz($event)"
                        prepend-inner-icon="person"
                      ></v-text-field>

                        <v-text-field
                        solo
                        :label="$t('Login.password')"
                        v-model="password"
                        class="CSChatThai"
                        :type="showPassword ? 'text' : 'password'"
                        style="text-align:center;"
                        @keyup.enter="login()"
                        @keypress="isnotthai($event)"
                        prepend-inner-icon="lock"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>

                        <div v-if="status == 'fail' " style="color: #f9a1a1;  width: 100%;"><v-icon style="color: #f9a1a1;">info</v-icon> {{failmessage}} </div>
                         <v-btn class="btnloginweb text-transform" @click="login()">{{$t('Login.Button.login')}}</v-btn>
                       <div style="padding-bottom:5vh;padding-top:1vh;text-align: center;">
                     <p class="CSChatThai text-transform" style="text-align: right;"><b><span class="forgetpass" @click="open_link('https://one.th/type_forgot_password')">{{$t('Login.forgotpass')}}?</span></b></p>
                       </div>
                     </v-form>
                   </div>
                 </v-card>
              <div style="text-align: right !important;">
               </div>
             </v-flex>
           </v-layout>
              </v-flex>
              <v-flex sm2 md2 lg2 xl2></v-flex>
            </v-layout>
          </v-container>
          <Download/>
        </v-layout>
        <v-layout column align-center justify-center
          id="mobile"
          class="white--text hidden-md-and-up scrolling-wrapper"
          style="background-color: white !important;background-size:auto 100%; height: calc(100vh - 64px); width: 100vw; background-repeat: no-repeat;margin-top: 4vh;">
          <v-layout row justify-center align-center v-if="progress">
            <v-flex xs12 sm12>
              <v-progress-circular :size="100" :width="7" indeterminate color="blue"></v-progress-circular>
            </v-flex>
          </v-layout>
          <v-container v-else grid-md text-xs-center style="height: calc(100vh - 64px);" class="scrolling-wrapper">
            <v-layout row justify-center align-center>
              <v-flex xs12 sm12 style="display: flex;justify-content: center;">
                <v-card class="elevation-24" flat style="height: auto; width: auto; justify-content: center; margin-top: 8vh; border-radius: 10px; background: #2562ae;">
                  <v-card-title primary-title style="width: 100%">
                    <v-layout row align-center justify-center>
                      <div class="headline Kanit">
                        <img src="/static/img/icons/logoonechat_full-white.png" style="height: 70px;">
                      </div>
                    </v-layout>

                   </v-card-title>
                   <div style="padding:0px 10%;" class="CSChatThai">
                     <v-form v-model="valid" >

                       <v-text-field
                        solo
                        :label="$t('Login.username')"
                        v-model="username"
                        class="CSChatThai"
                        style="text-align:center; color: white !important;"
                        @keyup.enter="login()"
                        :rules="usernameRules"
                        prepend-inner-icon="person"
                      ></v-text-field>

                      <v-text-field
                        solo
                        :label="$t('Login.password')"
                        v-model="password"
                        class="CSChatThai"
                        :type="showPassword ? 'text' : 'password'"
                        style="text-align:center;"
                        @keyup.enter="login()"
                        :rules="passwordRules"
                        prepend-inner-icon="lock"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>

                         <div v-if="status == 'fail' " style="color: #f9a1a1; width: 100%;"><v-icon style="color: #f9a1a1;">info</v-icon> {{failmessage}} </div>
                         <div class="text-xs-center CSChatThai" style="padding-bottom:30px;padding-top:0px;display: flex;justify-content: center;">

                          <v-layout align-center column justify-center>
                            <v-flex xs12 md12>
                              <v-layout align-center row justify-center>
                              <v-btn class="btnloginmobile text-transform" v-on:click="login()" :disabled="username == '' || password == ''">{{$t('Login.Button.login')}}</v-btn>
                              <br>
                            </v-layout>
                            <v-layout justify-end>
                                <p class="CSChatThai text-transform"><b><span @click="open_link('https://one.th/type_forgot_password')">{{$t('Login.forgotpass')}}?</span></b></p>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                         </div>
                     </v-form>
                   </div>
                 </v-card>
              </v-flex>
            </v-layout>
          </v-container>
          <Download/>
        </v-layout>
      </v-content>
      <checkconsentOnechatDialog :url_consent="url_consent" :consentOnechatDialog="consentOnechatDialog" @closeDialogConsentOnechat="closeDialogConsentOnechat"></checkconsentOnechatDialog>
      <newConsent :newConsentDialog="newConsentDialog" :newConsentDetail="newConsentDetail" @closeNewConsent="closeNewConsent"/>
    </main>
  </v-app>
</template>

<script>
import Vue from 'vue'
import VueCountdown from '@chenfengyuan/vue-countdown'
import Navbar from '@/components/homepage/Navbar'
import Download from '@/components/mobile/dialog/DownloadAppMobile'
import checkconsentOnechatDialog from '@/components/chat/dialog/consent/consent_onechat_dialog'
import newConsent from '@/components/consent/new_consent'
// import NewFooter from '@/components/home/NewFooter'
// import Vue from 'vue'
import { Encode, Decode } from '@/services'
import { sync } from 'vuex-pathify'
// import VueSocketio from 'vue-socket.io'
var _ = require('lodash')
var Centrifuge = require('centrifuge')
var centrifuge = new Centrifuge(process.env.WEB_centrifuge)

Vue.component(VueCountdown.name, VueCountdown)
export default {
  data () {
    return {
      newConsentDialog: false,
      newConsentDetail: {},
      consentOnechatDialog: false,
      url_consent: '',
      usernameRules: [
        v => this.regular_username_mobile()
      ],
      passwordRules: [
        v => this.regular_pass_mobile()
      ],
      valid: '',
      username: '',
      password: '',
      status: '',
      friend: '',
      status_login: '',
      progress: false,
      failmessage: this.$t('Alert.Login.invalidUserPass'),
      webdev: process.env.WEBchatdev,
      showPassword: false,
      url_redirect: process.env.AuthenOneid,
      // url_redirect: 'process.env.AuthenOneid',
      validmobile: '',
      type: 'first',
      phone: '',
      otpCode: '',
      Refcode: '',
      mobile_ref_id: '',
      type_otp: '',
      counting: false,
      loading: false
    }
  },
  computed: {
    ...sync('*')
  },
  created () {
    if (localStorage.getItem('Authenrization')) {
      this.status_login = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))['status_login']
      var token = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))['tokenuser']
      // console.log(this.status_login)
      this.connectCentrifuge(token)
      this.getOnechatToken(token)
      // if (this.status_login === 'T') {
      //   if (this.isMobile()) {
      //     this.$router.push('/mobile/homepage')
      //   } else {
      //     this.$router.push('/chat')
      //   }
      // }
    }

  },
  mounted () {
    console.log('mounted: ',localStorage.tologin);
    if(localStorage.tologin){
      this.type = 'phone'
      this.phone = localStorage.tologin
    }
  },
  methods: {
    closeNewConsent (value) {
      console.log("close new consent", value);
      this.newConsentDialog = value.close;
      this.newConsentDetail = {};
      // set localStorage authorization
      this.progress = true;
      localStorage.setItem('Authenrization', Encode.encode({'tokenuser': value.token, 'status_login': 'T', 'type_user': 'user'}))
        if (localStorage.getItem('botid_redirect') !== null) {
          this.progress = false;
          this.searchFriend(localStorage.getItem('botid_redirect'))
        } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
          this.progress = false;
          // redirect bot room with url
          var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
          this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
        } else {
          this.progress = false;
          // console.log(`this.isMobile(): ${this.isMobile()}`)
          if (window.innerWidth <= 960) {
            this.$router.push('/mobile/homepage')
          } else {
            this.$router.push('/chat')
          }
        }
    },
    connectCentrifuge (token) {
      var me = this
      var events = ''
      var data_msg = ''
      centrifuge.setToken(process.env.centrifuge_key);
      centrifuge.subscribe(token, function(message) {
        console.log(message.data.event)
        events = message.data.event
        if (events === 'consent') {
          // consent close dialog
          me.consentOnechatDialog = false
          me.getOnechatToken(token)
        }
      })
      centrifuge.on('connect', function() {
          console.log("connected centrifuge login");
      });
      centrifuge.on('disconnect', function() {
          console.log("disconnected centrifuge login");
      });
      centrifuge.connect();
    },
    closeDialogConsentOnechat (value) {
      this.consentOnechatDialog = value
    },
    getOnechatToken (token) {
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0')
      var hour = String(today.getHours() + 1).padStart(2, '0')
      var minute = String(today.getMinutes()).padStart(2, '0')
      var seconds = String(today.getSeconds()).padStart(2, '0')
      var milsec = today.getMilliseconds()
      var mm = String(today.getMonth() + 1).padStart(2, '0')
      var yyyy = today.getFullYear()
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00'
        dd = String(today.getDate() + 1).padStart(2, '0')
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1'
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1'
            yyyy = today.getFullYear() + 1
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0')
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
      // console.log(today)
      var expireddate = Date.parse(today)
      // console.log(expireddate)
      var body = Encode.encodeRichmenu({ 'userid': token, 'expired_date': expireddate })
      // console.log(body)
      this.progress = true
      // check new consent
      if (this.$cookie.get(`check-consent-${token}`) === null || this.$cookie.get(`check-consent-${token}`) === undefined) {
        // test new consent
        this.progress = false
        this.newConsentDialog = true
        this.newConsentDetail = {token: token}
      } else {
        this.progress = false
        // set localStorage authorization
        localStorage.setItem('Authenrization', Encode.encode({'tokenuser': token, 'status_login': 'T', 'type_user': 'user'}))
        if (localStorage.getItem('botid_redirect') !== null) {
          this.searchFriend(localStorage.getItem('botid_redirect'))
        } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
          // redirect bot room with url
          var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
          this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
        } else {
          // console.log(`this.isMobile(): ${this.isMobile()}`)
          if (window.innerWidth <= 960) {
            this.$router.push('/mobile/homepage')
          } else {
            this.$router.push('/chat')
          }
        }
      }

      // this.axios.post(process.env.APIgo_api + `/v1/get-consent`, { onechat_token: body }).then((response) => {
      //   // console.log(response.data)
      //   if (response.data.status === 'success') {
      //     this.progress = false
      //     if (response.data.data.consent_check === 'true') {
      //       // set localStorage authorization
      //       localStorage.setItem('Authenrization', Encode.encode({'tokenuser': token, 'status_login': 'T', 'type_user': 'user'}))
      //       if (localStorage.getItem('botid_redirect') !== null) {
      //         this.searchFriend(localStorage.getItem('botid_redirect'))
      //       } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
      //         // redirect bot room with url
      //         var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
      //         this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
      //       } else {
      //         // console.log(`this.isMobile(): ${this.isMobile()}`)
      //         if (window.innerWidth <= 960) {
      //           this.$router.push('/mobile/homepage')
      //         } else {
      //           this.$router.push('/chat')
      //         }
      //       }
      //     } else {
      //       // show dialog consent
      //       this.consentOnechatDialog = true
      //       this.url_consent = response.data.data.consent_url
      //       // clear localStorage autherization
      //       localStorage.removeItem('Authenrization')
      //       this.$router.push({path: '/login', force: true})
      //     }
      //   }
      // }).catch(err => {
      //   console.log(err)
      //   this.progress = false
      // })
    },
    handleCountdownEnd () {
      this.OTP = ''
      this.counting = false
    },
    open_link (link) {
      window.open(link, '_blank')
    },
    otp () {
      this.loading = true
      this.axios.post(process.env.APImanage + '/otp_login_and_regis', {phone: this.phone, type: 'login'}).then((response) => {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          if (response.data.type_otp == 'login') {
            this.loading = false
            this.Refcode = response.data.refcode
            this.mobile_ref_id = response.data.mobile_ref_id
            this.type_otp = response.data.type_otp
            this.counting = true
            this.type="otp"
          } else {
            this.loading = false
            this.phone = ''
            this.$swal(
              '',
              this.$t('Alert.Login.phoneNotVerify'),
              'error'
            )
          }
        } else if (response.data['message'] === 'No JSON object could be decoded') {
          this.loading = false
          this.$swal(
            '',
            this.$t('Alert.Fail.default.somethingWrong'),
            'error'
          )
        } else if (response.data['message'] === 'too many requests.') {
          this.loading = false
          this.$swal(
            '',
            this.$t('Alert.Login.otpRequest'),
            'error'
          )
        } else {
          this.loading = false
          this.$swal(
            response.data['status'],
            response.data['message'],
            'error'
          )
        }
      }, (error) => {
        console.log(error)
        this.status = 'fail'
        this.progress = false
        this.type='first'
        this.failmessage = this.$t('Alert.Fail.default.somethingWrong')
      })
    },
    loginWithotp () {
      this.progress = true
      var source = {type_otp: this.type_otp, phone: this.phone, otp: this.otpCode, mobile_ref_id: this.mobile_ref_id}
      this.axios.post(process.env.APImanage + '/login_and_regis', source).then((response) => {
        this.status = response.data['status']
        // console.log(response.data)
        if (this.status === 'success') {
          var profile = response.data['account']['profile']
          this.myprofilepicture = profile['profilepicture']
          this.myname = profile['name']
          // this.$cookie.set('language', 'th')
          this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
          localStorage.setItem('Authenrization', Encode.encode({'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type']}))
          localStorage.setItem('profilepicture', profile['profilepicture'])
          localStorage.setItem('name', profile['name'])
          localStorage.setItem('phone', profile['phone'])
          localStorage.setItem('email', profile['email'])
          localStorage.setItem('status', profile['status'])
          localStorage.setItem('type_user', profile['type'])
          localStorage.setItem('wallpaperInfo', JSON.stringify({
            'info': [{
              'room': '',
              'background': ''
            }]
          }))
          if (profile['username'] === '' || profile['username'] === 'None') {
            localStorage.setItem('status_username', 'false')
          } else {
            localStorage.setItem('status_username', 'true')
          }
          this.progress = false
          if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
            // this.$router.push('/chat')
            this.getOnechatToken(profile['tokenuser'])
          } else {
            this.$router.push(localStorage.getItem('pathRoom'))
          }
          localStorage.removeItem("tologin")
          localStorage.removeItem("tologin_keep2")
        } else if (response.data['message'] === 'The resource owner or authorization server denied the request.') {
          this.$cookie.set('status_login', 'F')
          this.progress = false
          this.$swal(
            '',
            this.$t('Alert.Login.otpInvalid'),
            'error'
          )
        } else {
          this.$cookie.set('status_login', 'F')
          this.progress = false
          this.$swal(
            this.status,
            response.data['message'],
            'error'
          )
        }
      }, (error) => {
        console.log(error)
        this.status = 'fail'
        this.progress = false
        this.failmessage = this.$t('Alert.Fail.default.somethingWrong')
      })
    },
    loginRedirect () {
      this.progress = true
      window.open(this.url_redirect, '_parent')
    },
    redirectUrl (url) {
      try {
        var link = document.getElementById("iframename").contentWindow.location.href
        // console.log(link)
        // console.log(_.includes(link, [process.env.redirect_url]))
        if(_.includes(link, [process.env.redirect_url])) {
          window.open(link + '&passlogin=true','_parent')
        }
      } catch(err) {
        console.log(err)
      }
    },
    regular_username_mobile () {
      // var str = this.username
      this.username = this.username.replace(/[^a-z-0-9@.]/i, '')
      this.username = this.username.toLowerCase()
    },
    regular_pass_mobile () {
      this.password = this.password.replace(/^[ก-๛]+/i, '')
    },
    isNumandaz ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      // console.log(keyCode)
      if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 97 && keyCode <= 122) && (keyCode != 46) && (keyCode != 64)) { // 46 is dot
        $event.preventDefault();
      }
    },
    isnotthai ($event) {
      // console.log($event)
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      // console.log(keyCode)
      if ((keyCode >= 3585 && keyCode <= 3642) || (keyCode >= 3647 && keyCode <= 3675)) { // 46 is dot
        $event.preventDefault();
      }
    },
    toNewTab () {
      window.open(this.webdev, '_parent').focus()
    },
    toPage (page) {
      this.$router.push(page)
    },
    isMobile () {
      if ($('#mobile').is(':hidden')) {
        return false
      } else {
        return true
      }
    },
    login () {
      var addyear = 10
      var newDate = new Date()
      newDate.setTime(newDate.getTime() + (addyear*365*24*60*60*1000))
      var expiresInTime = "expires="+ newDate.toUTCString()

      if (this.username === '' || this.password === '') {
        this.failmessage = this.$t('Alert.Login.inputUserPass')
      } else {
        this.progress = true
        var source = Encode.encode({'username': this.username, 'password': this.password})
        this.axios.post(process.env.APImanage + '/loginuserwithbusiness', {source: source}).then((response) => {
          // console.log(response.data)
          this.status = response.data['status']
          if (this.status === 'success') {
            var profile = response.data['account']['profile']
            // localStorage.setItem('status_login', 'T')
            this.myprofilepicture = profile['profilepicture']
            this.myname = profile['name']
            // this.$cookie.set('status_login', 'T')
            // this.$cookie.set('tokenuser', Encode.encodeToken(profile['tokenuser']))
            // this.$cookie.set('language', 'th')
            this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
            localStorage.setItem('Authenrization', Encode.encode({'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type']}))
            localStorage.setItem('profilepicture', profile['profilepicture'])
            localStorage.setItem('name', profile['name'])
            localStorage.setItem('phone', profile['phone'])
            localStorage.setItem('email', profile['email'])
            localStorage.setItem('status', profile['status'])
            localStorage.setItem('type_user', profile['type'])
            localStorage.setItem('wallpaperInfo', JSON.stringify({
              'info': [{
                'room': '',
                'background': ''
              }]
            }))
            if (profile['username'] === '' || profile['username'] === 'None') {
              localStorage.setItem('status_username', 'false')
            } else {
              localStorage.setItem('status_username', 'true')
            }
            this.progress = false
            // connect centrifuge
            this.connectCentrifuge(profile['tokenuser'])
            if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
              this.getOnechatToken(profile['tokenuser'])
              // if (localStorage.getItem('botid_redirect') !== null) {
              //   this.searchFriend(localStorage.getItem('botid_redirect'))
              // } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
              //   // redirect bot room with url
              //   var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
              //   this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
              // } else {
              //   if (this.isMobile()) {
              //     this.$router.push('/mobile/homepage')
              //   } else {
              //     this.$router.push('/chat')
              //   }
              // }
            } else {
              this.$router.push(localStorage.getItem('pathRoom'))
            }
          } else {
            this.$cookie.set('status_login', 'F')
            this.progress = false
            if (response.data['message'] === 'Wrong Username / Password') {
              this.failmessage = this.$t('Alert.Login.invalidUserPass')
            } else {
              this.failmessage = this.$t('Alert.Fail.default.somethingWrong')
            }
          }
        }, (error) => {
          console.log(error)
          this.status = 'fail'
          this.progress = false
          this.failmessage = this.$t('Alert.Fail.default.somethingWrong')
        })
      }
    },
    searchFriend (botid) {
      // console.log(`bot id : ${localStorage.getItem('botid_redirect')}`)
      if (localStorage.getItem('botid_redirect') !== null) {
        this.progress = true
        var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
        this.axios.post(process.env.APIsearchfriend, {
          tokenbot: botid,
          tokenuser: decoded.tokenuser
        }).then((response) => {
          this.progress = false
          // console.log(response.data.listuser)
          if (response.data.listuser.length === 0) {
            if (window.innerWidth <= 960) {
              this.$router.push('/mobile/homepage')
            } else {
              this.$router.push('/chat')
            }
          } else {
            if (response.data.listuser.relation === 'friend') {
              localStorage.removeItem('botid_redirect')
              if (this.isMobile()) {
                this.$router.push('/mobile/room/' + response.data.listuser.user.tokenroom)
              } else {
                this.$router.push('/chat/room/' + response.data.listuser.user.tokenroom)
              }
            } else {
              console.log('not friend')
              this.$router.push('/addbot/' + localStorage.getItem('botid_redirect'))
            }
          }
        }).catch(error => {
          console.log(error)
          localStorage.removeItem('botid_redirect')
          this.progress = false
          // this.$swal('', 'ไม่มีข้อมูลบอทในระบบ กรุณาตรวจสอบข้อมูลให้ถูกต้อง', 'warning')
          if (window.innerWidth <= 960) {
            this.$router.push('/mobile/homepage')
          } else {
            this.$router.push('/chat')
          }
        })
      }
    },
  },
  components: {
    Navbar,
    Download,
    checkconsentOnechatDialog,
    newConsent
  }
}
</script>
<style type="text/css" scoped>
.text-transform {
  text-transform: none !important;
}
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
>>>.v-messages__message {
  margin-bottom: 2px;
  margin-top: 2px;
  line-height: 1;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}
>>>.error--text {
  color: #ff7979 !important;
  caret-color: #ff7979 !important;
}
.forgetpass {
  color: white !important;
  cursor: pointer !important;
}
.forgetpass:hover {
  color: white !important;
  cursor: pointer !important;
  text-decoration: underline !important;
}
a:link {
    text-decoration: none;
    color: white !important;
}

a:visited {
    color: white !important;
    text-decoration: none;
}

a:hover {
    color: #2562af !important;
    text-decoration: none;
}

a:active {
    color: white !important;
    text-decoration: none;
}
.footer {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: white !important;
   color: white;
   text-align: center;
}
.footermo {
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: #00000000 !important;
   color: white;
   text-align: center;
   margin-top: 20px;
}
.application .theme--light.card, .theme--light .card {
    background-color:  #2562af !important;
}
html, body {
  overflow: scroll;
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.btnloginmobile {
  /* width: 30%; */
  width: 125px !important;
  font-size: 14px;
  color: white !important;
  margin-top: 1vh !important;
  background-color: #2562af!important;
  border: 2px solid white;
  border-radius: 30px;
}
.btnloginmobile:disabled {
  width: 125px !important;
  font-size: 14px;
  /* color: white !important; */
  margin-top: 1vh !important;
  background-color: #5f9cea !important;
  border-radius: 30px;
}
>>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat) {
  border-color: #5e9cea !important;
  background-color: #5f9cea!important;
}

.btnloginweb {
  color: white !important;
  width:40%;
  margin-top: 1vh !important;
  background-color: #2562af !important;
  /*border-radius: 10px;*/
  border: 2px solid white;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}
.btnloginwebOneid {
  color: white !important;
  margin-top: 1vh !important;
  width:80%;
  background-color: #2562af !important;
  /*border-radius: 10px;*/
  border: 2px solid white;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}
.btnloginwebOneid_white {
  color: #2562af !important;
  margin-top: 1vh !important;
  width:80%;
  background-color: white !important;
  /*border-radius: 10px;*/
  border: 2px solid #2562af;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}

.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}

.textor {
  color: white;
}

.textor:after,
.textor:before{
    content:"\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0";
    text-decoration:line-through;
    color: white;
}


>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12) !important;
    border-radius: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/login.vue